import { render } from "./Banner.vue?vue&type=template&id=90a77d46&scoped=true"
const script = {}

import "./Banner.vue?vue&type=style&index=0&id=90a77d46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90a77d46"]])

export default __exports__